/* Package JSON Import will be here */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Constants } from '../appConstants';

import AuthenticateRoute from './authenticateRoute';
import PublicRoute from './publicRoute';
import NotFound from '../../scenes/sharedComponent/notFound/index';
import SplashScreen from '../../scenes/splashscreen/index';
import Login from '../../scenes/login/login.Container';
import Register from '../../scenes/register/register.Container';
import TimeCard from '../../scenes/timeCard/timeCard.Container';
import Employee from '../../scenes/employee/employee.Container';
import Read from '../../scenes/developer/crud/index';
import ImageUpload from '../../scenes/developer/image-upload/index';
import CreateTaskGroup from '../../scenes/employee/selectTask/CreateTaskGroup/createTaskGroup.Container';
import CurrentWeekTimeCard from '../../scenes/timeCard/currentWeekTimeCard/currentWeekTimeCard.Container';
import PreviousWeekTimeCard from '../../scenes/timeCard/previousWeekTimeCard/previousWeekTimeCard.Container';
import SubmittedTimeCard from '../../scenes/timeCard/submittedTimeCard/submittedTimeCard.Container';
// import TimeCardDetailsEdit from '../../scenes/timeCard/timecardEdit/timeCardDetailsEdit.Container';
import CreateEmpGroup from '../../scenes/employee/createEmpGroup/createEmpGroup.Container';
import TimeCardDetailsEdit from '../../scenes/timeCard/timecardEdit/timeCardDetailsEdit.Container';
import DailyDetails from '../../scenes/timeCard/dailyDetails/dailyDetails.Container';
import TMVoucherDataEntry from '../../scenes/timeCard/TMVoucher/TMVoucherDataEntry.Container';
import TMVoucherPDFViewer from '../../scenes/timeCard/TMVoucher/TMVoucherPDFViewer/TMVoucherPDFViewer.Container';
import Attestation from '../../scenes/timeCard/Attestation/Attestation.Container';

/* Package JSON Import will be here */

/* Project Import will be here */

/* -------------------- Common Component will be here --------------------*/
/* Account Component will be here */

/* Project Import will be here */

//todo: Make route path url's as path constants to resuse path's constants on route navigations
const Routers = (props) => {
    
    return (
        <Switch>
            <Route exact path="/" render={(props) => <SplashScreen {...props} />} />
            <PublicRoute component={Login} path="/login" />
            <PublicRoute component={Register} path="/register" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.TIMECARD_PAGE} component={TimeCard} path="/TimeCard" />           
            <AuthenticateRoute component={Employee} path="/addtimecard" />
            <AuthenticateRoute component={TimeCardDetailsEdit} path="/edittimecard" />
            <AuthenticateRoute component={CreateEmpGroup} path="/createEmpGroup" />
            <AuthenticateRoute component={CreateTaskGroup} path="/CreateTaskGroup" />
            <AuthenticateRoute component={CurrentWeekTimeCard} path="/CurrentWeekTimeCard" />
            <AuthenticateRoute component={PreviousWeekTimeCard} path="/PreviousWeekTimeCard" />
            <AuthenticateRoute component={SubmittedTimeCard} path="/SubmittedTimeCard" />
            <AuthenticateRoute component={DailyDetails} path="/DailyDetails" />
            <AuthenticateRoute component={TMVoucherDataEntry} path="/TMVoucherDataEntry" />
            <AuthenticateRoute component={TMVoucherPDFViewer} path="/TMVoucherPDFViewer" />
            <AuthenticateRoute component={Attestation} path="/Attestation" />
            {/* <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.TIMECARD_PAGE} component={Employee} path="/Employee" /> */}
            {/* <Route exact path="/" render={(props) => <TimeCardDetailsEdit {...props} />} />         
            <Route component={TimeCardDetailsEdit} path="/TimeCardDetailsEdit" />                                */}

            {/* ONLY FOR DEVELOPER REFERENCE */}
            {/* SHOULD BE COMMENTED OUT DURING DEPLOYMENT */}
            <Route component={Read} path="/curd-operation-example" />
            <Route component={ImageUpload} path="/image-upload-example" />

            <Route path="*" component={NotFound} />
        </Switch>
    );
};

export default Routers;

Routers.displayName = 'Router';